import * as d3 from 'd3'

export const draw_y_axis_label = (instance, { height, margin, y_axis }) => {
    instance.append('text')
        .attr('text-anchor', 'middle')
        .attr('x', margin.left - y_axis.label_distance)
        .attr('y', height/2)
        .attr('class', 'vertical_text')
        .text(y_axis.label)
}

export const draw_y_axis2_label = (instance, { height, width,  margin, y_axis }) => {
    instance.append('text')
        .attr('text-anchor', 'middle')
        .attr('x',  width + margin.left +  y_axis.label_distance)
        .attr('y', height/2)
        .attr('class', 'vertical_text')
        .text(y_axis.label)
}

export const get_scale_y = ({ height, y_axis }) => {
    return d3.scaleLinear()
        .domain([y_axis.min_value, y_axis.max_value])
        .range([height, 0])
}

export const draw_y_axis_tick = (instance, { margin, scale, y_axis }) => {
    instance.append('g')
        .attr('id', 'Y_AXIS')
        .attr('transform', `translate(${margin.left}, 0)`)
        .call(d3.axisLeft(scale)
            .tickFormat((d, i) => i % y_axis.display_interval === 0 ? d : '')
            .ticks(y_axis.ticks)
        )
}

export const draw_y_axis2_tick = (instance, { margin, width, scale, y_axis }) => {
    instance.append('g')
        .attr('id', 'Y_AXIS2')
        .attr('transform', `translate(${margin.left + width}, 0)`)
        .call(d3.axisRight(scale)
            .tickFormat((d, i) => i % y_axis.display_interval === 0 ? d : '')
            .ticks(y_axis.ticks)
        )
}

export const draw_y_axis_basic_background = (instance, { id, width, margin }) => {
    // tick 顏色分階
    const tick_y_list = [...document.querySelectorAll(`#${id} #Y_AXIS .tick`)].map((d) => {
        const tick_height = d.getAttribute('transform').match(/translate\(0,([^)]+)\)/);
        return tick_height[1]
    });
    const tickRectHeight = tick_y_list[0] - tick_y_list[1];
    const init_white_height = parseFloat(tick_y_list[tick_y_list.length - 1])
    
    tick_y_list.forEach((d, i) => {
        instance.append('rect')
            .attr('fill', '#e8ecf7')
            .attr('width', width)
            .attr('height', 1)
            .attr('x', margin.left + 1)
            .attr('y', init_white_height + tickRectHeight*i)
    })
}